import { Document, Page, Text, View, StyleSheet, PDFViewer } from "@react-pdf/renderer"
import { useLocation } from "react-router-dom";

// Define styles
const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        backgroundColor: "#ffffff",
        padding: 30,
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    title: {
        fontSize: 24,
        textAlign: "center",
        marginBottom: 20,
    },
    subtitle: {
        fontSize: 18,
        marginBottom: 10,
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10,
    },
})

const PdiFormpdf = () => {
    const location = useLocation();
    const formData = location.state?.formData; 

    if (!formData) {
        return <Text>Loading...</Text>; 
    }

    return (
        <div style={{ width: "100%", height: "100vh" }}>
        <PDFViewer style={{width:"100%",height:"100%"}}>
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        <Text style={styles.title}>PRECISION PRODUCTS</Text>
                        <Text style={styles.subtitle}>Consumer Inspection Report</Text>

                        {/* Consumer Details */}
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Consumer Name: {formData.consumerName}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Comp. Name: {formData.compname}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Drg No: {formData.drgno}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Part No: {formData.partName}</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>P.O. No: {formData.pono}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Lot No: {formData.lotno}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Qty No: {formData.qtyno}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Rework: {formData.rework}</Text>
                                </View>
                            </View>
                        </View>

                        {/* Observed Dimensions Table */}
                        <Text style={styles.subtitle}>Observed Dimensions</Text>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "10%" }]}>
                                    <Text style={styles.tableCell}>S.NO.</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={styles.tableCell}>Description</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={styles.tableCell}>Specified Dimensions</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%" }]}>
                                    <Text style={styles.tableCell}>Observed Dimensions</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={styles.tableCell}>Remarks</Text>
                                </View>
                            </View>
                            {formData.table?.map((row, index) => (
                                <View style={styles.tableRow} key={row.id || index}>
                                    <View style={[styles.tableCol, { width: "10%" }]}>
                                        <Text style={styles.tableCell}>{index + 1}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "20%" }]}>
                                        <Text style={styles.tableCell}>{row.description}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "20%" }]}>
                                        <Text style={styles.tableCell}>{row.specifiedDimensions}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "30%" }]}>
                                        <Text style={styles.tableCell}>{row.observedDimensions?.join(", ")}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "20%" }]}>
                                        <Text style={styles.tableCell}>{row.remarks}</Text>
                                    </View>
                                </View>
                            ))}
                        </View>

                        {/* Rejected Parameters */}
                        <Text style={styles.subtitle}>Rejected Parameters</Text>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Dimension: {formData.dimension}</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.tableCell}>Material: {formData.material}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
        </div>

    );
};

export default PdiFormpdf;
